import React from 'react'
import { BoxHeader, BoxTitle } from '../../ui/box'
import Shorten from '../../helper/shorten'
import { TraceSpanCategory } from '../../domain/Trace'

type Props = {
    category: TraceSpanCategory
    isRoot: boolean
    name: string
    namespace?: string
    async?: true
}

export class TraceDetailsTitle extends React.PureComponent<Props> {
    render() {
        const { category, name, namespace, async } = this.props
        return (
            <BoxHeader>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline' }}>
                    <div className={'category category-' + category.className}>{category.label}</div>
                    {async ? (
                        <div
                            className="category category-default tw-tooltip tw-tooltip--bottom tw-tooltip-dataText"
                            data-tooltip-text="This span does not represent a continuously executed blocking activity."
                            style={{ color: 'black' }}
                        >
                            Async
                        </div>
                    ) : null}
                    <div>
                        <BoxTitle>
                            <Shorten string={name} />
                        </BoxTitle>
                        {namespace ? <h4 className="box-title namespace">{namespace}</h4> : null}
                    </div>
                </div>
            </BoxHeader>
        )
    }
}
